import { render } from "./VSelect.vue?vue&type=template&id=66cc228e"
import script from "./VSelect.vue?vue&type=script&lang=js"
export * from "./VSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__